export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverRoleEnum_AllergyDoctor": "Lægen",
	"CaregiverRoleEnum_Dentist": "Tannlege",
	"CaregiverRoleEnum_Dermatologist": "Hudlegen",
	"CaregiverRoleEnum_Doctor": "Fastlegen",
	"CaregiverRoleEnum_Midwife": "Jordmor",
	"CaregiverRoleEnum_Nurse": "Helsesøster",
	"CaregiverRoleEnum_Physiotherapist": "Fysioterapeuten",
	"CaregiverRoleEnum_Psychologist": "Psykologen",
	"CaregiverRoleEnum_Rheumatologist": "Reumatologer",
	"CaregiverRoleEnum_SundVaegtDoctor": "HealthyWeight-legen",
	"CaregiverRoleEnum_SundVaegtNurse": "HealthyWeight-sykepleieren",
	"CaregiverRoleEnum_Dietitian": "Kostholdseksperten",
	"CaregiverRoleEnum_AcneDermatologist": "Hudlegen",
	"CaregiverRoleEnum_Veterinarian": "Dyrlege",
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": "Læge",
	"CaregiverRoleEnum_Dentist_Indefinite": "Tannlege",
	"CaregiverRoleEnum_Dermatologist_Indefinite": "Hudlege",
	"CaregiverRoleEnum_Doctor_Indefinite": "Fastlege",
	"CaregiverRoleEnum_Midwife_Indefinite": "Jordmor",
	"CaregiverRoleEnum_Nurse_Indefinite": "Helsesøster",
	"CaregiverRoleEnum_Physiotherapist_Indefinite": "Fysioterapeut",
	"CaregiverRoleEnum_Psychologist_Indefinite": "Psykolog",
	"CaregiverRoleEnum_Rheumatologist_Indefinite": "Reumatologer",
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": "HealthyWeight-lege",
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": "HealthyWeight-sykepleiere",
	"CaregiverRoleEnum_Dietitian_Indefinite": "Kostholdsekspert",
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": "Hudlege",
	"CaregiverRoleEnum_Veterinarian_Indefinite": "Dyrlege",
	"ConsultationPaymentProviderEnum_ApplePay": "App Store",
	"ConsultationPaymentProviderEnum_Company": "Foretagende",
	"ConsultationPaymentProviderEnum_Coupon": "Kupong",
	"ConsultationPaymentProviderEnum_DIBS": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_ePay": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_GoogleWallet": "Google Play",
	"ConsultationPaymentProviderEnum_GracePeriod": "Gratis svar",
	"ConsultationPaymentProviderEnum_ReepayCheckout": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_Repay": "Én konsultasjon",
	"ConsultationPaymentProviderEnum_Subscription": "Abonnement",
	"ConsultationPaymentProviderEnum_PriceOverride": "-",
	"ConsultationTypeEnum_AllergyCheckVideo": "Allergisjekk",
	"ConsultationTypeEnum_DentistMessage": "Tekstkonsultasjon - tannlege",
	"ConsultationTypeEnum_DentistVideo": "Videokonsultasjon - tannlege",
	"ConsultationTypeEnum_DermatologistMessage": "Tekstkonsultasjon - hudlege",
	"ConsultationTypeEnum_DermatologistVideo": "Videokonsultasjon - hudlege",
	"ConsultationTypeEnum_Message": "Tekstkonsultasjon - lege",
	"ConsultationTypeEnum_MidwifeMessage": "Tekstkonsultasjon - jordmor",
	"ConsultationTypeEnum_MidwifeVideo": "Videokonsultasjon - jordmor",
	"ConsultationTypeEnum_NurseMessage": "Tekstkonsultasjon - helsesøster",
	"ConsultationTypeEnum_NurseVideo": "Videokonsultasjon - helsesøster",
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": "Videokonsultasjon - fysioterapeut oppstart",
	"ConsultationTypeEnum_PhysiotherapistMessage": "Tekstkonsultasjon - fysioterapeut",
	"ConsultationTypeEnum_Prescription": "Fornyelse av resept",
	"ConsultationTypeEnum_PsychologistVideo": "Videokonsultasjon - psykolog",
	"ConsultationTypeEnum_PsychologistCrisisVideo": "Videokonsultasjon - krisepsykolog",
	"ConsultationTypeEnum_RheumatologistVideo": "Videokonsultasjon - revmatolog",
	"ConsultationTypeEnum_SundVaegtStartupMessage": "HealthyWeight oppstart",
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": "Sunn vektkontroll",
	"ConsultationTypeEnum_Video": "Videokonsultasjon - lege",
	"ConsultationTypeEnum_DietitianStartupVideo": "Videokonsultasjon - oppstart av kostholdsekspert",
	"PlanInterval_Day": "Daglig",
	"PlanInterval_Month": "Månedlig",
	"PlanInterval_Week": "Ukentlig",
	"PlanInterval_Year": "Årlig",
	"ServiceTypeEnum_AllergyCheck": "Allergisjekk: Videokonsultasjon",
	"ServiceTypeEnum_DermatologistMessage": "Hudlege: Tekstkonsultasjon",
	"ServiceTypeEnum_DermatologistMessageReply": "Hudlege: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_DermatologistVideo": "Hudlege: Videokonsultasjon",
	"ServiceTypeEnum_Message": "Lege: Tekstkonsultasjon",
	"ServiceTypeEnum_MessageReply": "Lege: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_PhysiotherapistStartupVideo": "Fysioterapeut: Oppstart av videokonsultasjon",
	"ServiceTypeEnum_PhysiotherapistMessage": "Fysioterapeut: Tekstkonsultasjon",
	"ServiceTypeEnum_PhysiotherapistMessageReply": "Fysioterapeut: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_Prescription": "Lege: Fornyelse av resept",
	"ServiceTypeEnum_PsychologistVideo": "Psykolog: Videokonsultasjon",
	"ServiceTypeEnum_PsychologistCrisisVideo": "Krisepsykolog: Videokonsultasjon",
	"ServiceTypeEnum_RheumatologistVideo": "Revmatolog: Videokonsultasjon",
	"ServiceTypeEnum_SundVaegtStartupMessage": "HealthyWeight oppstart",
	"ServiceTypeEnum_VideoConsultation": "Lege: Videokonsultasjon",
	"ServiceTypeEnum_AllergyCheckVideo": "Allergisjekk",
	"ServiceTypeEnum_DietitianStartupVideo": "Kostholdsekspert: Oppstart av videokonsultasjon",
	"UserTypeEnum_Admin": "Administrator",
	"UserTypeEnum_Doctor": "Behandler",
	"UserTypeEnum_Patient": "Pasient",
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": "HealthyWeight lege: Videokonsultasjon",
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": "HealthyWeight lege: Videokonsultasjon",
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": "HealthyWeight sykepleier: Videokontroll",
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": "HealthyWeight Nurse: Tekstkonsultasjon",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": "HealthyWeight Nurse: Tekstkonsultasjon",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": "HealthyWeight sykepleier: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": "HealthyWeight spørreskjema: Svar",
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": "Sunn vektkontroll",
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": "HealthyWeight sykepleier: Videokonsultasjon",
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": "HealthyWeight spørreskjema",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": "HealthyWeight spørreskjema",
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": "Videokonsultasjon - fysioterapeut",
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": "Fysioterapeut: Videokonsultasjon",
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": "Spørreskjema til fysioterapeut",
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": "Fysioterapeut: spørreskjema",
	"ServiceTypeEnum_SundVaegtStartupMessageReply": "HealthyWeight oppstart: Svar",
	"SubscriptionStatusEnum_Active": "Aktiv",
	"SubscriptionStatusEnum_Canceled": "Afmeldt",
	"SubscriptionStatusEnum_Expired": "Udløbet",
	"SubscriptionStatusEnum_PastDue": "Skyldig",
	"SubscriptionStatusEnum_Trialing": "Gratis prøve",
	"SubscriptionStatusEnum_Unknown": "Ukjent",
	"ConsultationTypeEnum_DietitianCheckupVideo": "Videokonsultasjon - kostholdsekspert oppfølging",
	"ServiceTypeEnum_DietitianCheckupVideo": "Kostholdsekspert: Oppfølging av videokonsultasjon",
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": "Upload bilag konsultation - diætist",
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": "Diætist: Upload bilag konsultation",
	"ServiceTypeEnum_DietitianVideo": "Kostholdsekspert: Videokonsultasjon",
	"AllergyCheckVideo": "Allergisjekk",
	"ConsultationTypeEnum_AllergyCheck": "Allergisjekk",
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": "Starte et personlig helseprogram",
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": "Starte et personlig helseprogram",
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": "Oppstart av aknekurs",
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": "Oppstart av aknekurs video",
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": "Oppfølging av video om aknekurs",
	"ServiceTypeEnum_AcneProgrammeStartupMessage": "Oppstart av aknekurs",
	"ServiceTypeEnum_AcneProgrammeStartupVideo": "Oppstart av aknekurs video",
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": "Oppfølging av video om aknekurs",
	"ConsultationTypeEnum_AcneDermatologistMessage": "Tekstkonsultasjon - hudlege",
	"ServiceTypeEnum_AcneDermatologistMessage": "Hudlege: Tekstkonsultasjon",
	"ServiceTypeEnum_AcneDermatologistMessageReply": "Hudlege: Svar på tekstkonsultasjon",
	"ServiceTypeEnum_VeterinarianVideo": "Veterinær: Videokonsultasjon",
	"ConsultationPaymentProviderEnum_Free": "Gratis",
	"ConsultationTypeEnum_VeterinarianVideo": "Videokonsultasjon – veterinær",
	"PetSex_Female": "Hun",
	"PetSex_FemaleSterilized": "Sterilisert kvinne",
	"PetSex_Male": "Han",
	"PetSex_MaleNeutered": "Kastrert hann",
	"PetSex_Unknown": "Ukjent",
	"PetType_Dog": "Hund",
	"PetType_Cat": "Kat",
	"PetType_Rabbit": "Kanin",
	"PetType_Rodent": "Gnaver",
	"VetConsultationReasonEnum_Gastrointestinal": "Gastrointestinal",
	"VetConsultationReasonEnum_SkinCoatEars": "Hud, pels og ører (inkl. sår og analkjertler)",
	"VetConsultationReasonEnum_Poisoning": "Forgiftning",
	"VetConsultationReasonEnum_Eyes": "Øyne",
	"VetConsultationReasonEnum_UrinaryTract": "Urinveier",
	"VetConsultationReasonEnum_Lameness": "Halthet",
	"VetConsultationReasonEnum_RespiratoryTract": "Luftveier",
	"VetConsultationReasonEnum_OralCavity": "Munnhule og tenner",
	"VetConsultationReasonEnum_Pain": "Smerte/feber/nedstemthet",
	"VetConsultationReasonEnum_Claws": "Klør",
	"VetConsultationReasonEnum_GenitalsMammaryGlands": "Genitalier og melkekjertler",
	"VetConsultationReasonEnum_ReproductionCycle": "Reproduksjon og syklus",
	"VetConsultationReasonEnum_Behaviour": "Atferd",
	"VetConsultationReasonEnum_Prescription": "Resept",
	"VetConsultationReasonEnum_OtherReason": "Annet",
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": "Rådet til behandling hjemme (inkludert tilfeller som ikke krever behandling)",
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": "Henvist i vanlig åpningstid",
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": "Henvist utenom vanlig åpningstid"
}